import packageJson from '../../package.json';

const getVersion = () => packageJson.version;

const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      console.log('clear cache name : ', name);
      caches.delete(name);
    });
    if (process.env.NODE_ENV === 'production') window.location.reload();
  });
};

export { getVersion, clearCacheData };
